import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

function GuideSnackbar() {
  const navigate = useNavigate();
  return (
    <Container>
      <Text>땅집고옥션 사용방법이 궁금하신가요?</Text>
      <Button
        onClick={() => {
          navigate('/guide');
          // window.open(`/guide`, '_blank');
        }}
      >
        방법 보기
      </Button>
    </Container>
  );
}

export default GuideSnackbar;

const Container = styled.div`
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1999;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 24px;
  border-radius: 12px;
  padding: 14px;
  background-color: #eaf2fe;
  backdrop-filter: blur(5px);
  box-shadow: 0px 1px 12px 0px #00000014;
  white-space: nowrap;
`;

const Text = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 13px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
`;

const Button = styled.button`
  border-radius: 8px;
  padding: 6px 14px;
  background-color: #008aff;
  color: #ffffff;
  cursor: pointer;
  border: none;

  font-weight: 500;
  font-size: 12px;
`;
